export default {
  menu: 'Gateways',
  title: 'Gateways',

  general: {
    labels: {
      status: 'Status',
      type: 'Type',
      bank: 'Clearing bank',
      title: 'Portal Title',
      endTime: 'Ports working day end time',
      merchantCode: 'Acceptor code',
      terminalCode: 'Terminal code',
      description: 'Description',
      provider: 'Provider',
      payment_gateway: 'Gateway',
      delete: 'Delete payment gateway'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        balance: 'Inventory',
        bank: 'Clearing bank',
        status: 'Status',
        title: 'Portal Title',
        type: 'Port type',
        row: 'Row'
      }
    },

    types: {
      all: 'All',
      pos: 'POS',
      online: 'Internet'
    },

    status: {
      all: 'All',
      enable: 'enabled',
      disable: 'inactive'
    },

    confirmations: {
      emptyGateway: {
        title: 'No gateway available',
        body: 'To create {name}, you need to connect a gateway. Please create one first.'
      },
      delete: {
        title: 'Confirmation of payment gateway removal',
        body: 'Are you sure you want to delete "{paymentGateway}" permanently?',
        body1: 'Are you sure you want to delete "{paymentGateway}" temporarily?'
      }
    },

    notifications: {
      incorrectData: 'The information was not entered correctly',

      insert: {
        success: 'Payment gateway created successfully',
        error: 'There was an error creating the payment gateway'
      },

      edit: {
        success: 'Payment gateway successfully updated',
        error: 'Payment gateway update encountered error'
      },

      delete: {
        success: 'Payment gateway successfully deleted',
        error: 'Deleting the payment gateway was accompanied by an error'
      },

      restore: {
        success: 'Payment gateway successfully restored',
        error: 'There was an error returning the payment gateway'
      }
    }
  },

  insert: {
    title: 'Add payment gateway',
    suggestTitle: '{type} Bank {bank}'
  },

  list: {
    title: 'Gateways'
  },

  trash: {
    title: 'Payment gateways Trash'
  },

  edit: {
    title: 'Edit Payment Gateway',
    dynamicTitle: 'Edit {paymentGateway}'
  },

  paymentGateway: {
    title: 'Payment gateway',
    dynamicTitle: '{paymentGateway}',

    importantData: {
      type: 'type',
      bank: 'clearing bank',
      balance: 'Inventory'
    },

    actions: {
      transactions: 'financial turnover',
      receive: 'Receipt notification',
      logs: 'Time lines'
    }
  },

  transactions: {
    title: 'Payment gateway turnover',
    dynamicTitle: 'Turnover {paymentGateway}',

    table: {
      header: {
        balance: 'Inventory',
        price: 'Amount',
        description: 'Documents',
        date: 'Date',
        docNumber: 'Document number'
      }
    }
  },

  logs: {
    title: 'Payment gateway logs'
  },

  receive: {
    title: 'Notice of receipt of payment gateway',
    dynamicTitle: 'Receipt Receipt {paymentGateway}',

    labels: {
      receivedBalance: 'Amount received',
      hasWage: 'Fee',
      wage: 'Fee deduction',
      receiveBalanceWithWage: 'Total Price of receipt and fee',
      receivedBalanceTransferId: 'Tracking number',
      totalBalance: 'Total balance',
      receivedYesterdayBalance: 'Total receivable balance'
    },

    notifications: {
      balanceIsNotEnough: 'The amount entered is more than the port balance',
      incorrectPriceOrId: 'The amount or reference id was not entered correctly',
      incorrect_reference_id: 'reference id is not correct',

      receive: {
        success: 'Receipt notified successfully',
        error: 'Receipt notified failed'
      }
    }
  }
}
